import { jsx as _jsx } from "react/jsx-runtime";
import { TextInput } from '../../inputs/TextInput/TextInput';
import { Box } from '../../layout/Box';
import { GridList } from '../GridList/GridList';
export const DataGrid = ({ data, config, emptyValue, itemMinWidth, }) => {
    const mappedItems = config.map(({ key, render, label, testId, renderBeforeElement, renderAfterElement, }) => {
        const value = render(data) || emptyValue;
        const evaluatedLabel = typeof label === 'function' ? label(data) : label;
        const beforeElement = renderBeforeElement?.(data);
        const beforeElementFinal = beforeElement ? (_jsx(Box, { spacingRight: '1/2', children: beforeElement })) : undefined;
        const afterElement = renderAfterElement?.(data);
        const afterElementFinal = afterElement ? (_jsx(Box, { spacingLeft: '1/2', children: afterElement })) : undefined;
        return (_jsx(TextInput, { label: evaluatedLabel, value: value, testId: testId, beforeElement: beforeElementFinal, afterElement: afterElementFinal, readOnly: true }, key));
    });
    return _jsx(GridList, { itemMinWidth: itemMinWidth, children: mappedItems });
};
